<template>
  <div class="verification_box">
    <p class="verification_warning">
      平台将提交一笔随机数目的打款申请，因银行处理速度不同，请耐心等待，查询银行收支明细后，在此输入打款金额进行验证，您共有五次验证机会，五次错误后将关闭流程，请谨慎！
    </p>
    <van-cell-group class="verification_form">
      <van-field
        input-align="right"
        key="bankName"
        name="bank_acct_name"
        v-model="bank_acct_name"
        label="开户名称"
      >
        <template #input>
          {{ bank_acct_name }}
        </template>
      </van-field>
      <van-field
        input-align="right"
        key="bankNo"
        name="bank_name"
        v-model="bank_name"
        label="开户银行"
      >
        <template #input>
          {{ bank_name }}
        </template>
      </van-field>
      <van-field
        input-align="right"
        key="bankAccount"
        name="bank_acct_no"
        v-model="bank_acct_no"
        label="银行账户"
      >
        <template #input>
          {{ bank_acct_no }}
        </template>
      </van-field>
      <van-field
        input-align="right"
        key="transAmt"
        name="trans_amt"
        v-model="trans_amt"
        label="收款金额"
        placeholder="请输入"
        :rules="[{ required: true, message: '请输入收款金额' }]"
      />
    </van-cell-group>
    <p class="verification_error">
      <span @click="errorShow = true">尚未收到打款？</span>
    </p>
    <div class="verification_btn_box">
      <van-button round type="info" class="verification_btn" @click="toVerify"
        >下一步</van-button
      >
    </div>
    <van-dialog
      :value="errorShow"
      theme="round-button"
      confirmButtonText="重新打款"
      confirmButtonColor="#4b79f2"
      :closeOnClickOverlay="true"
      @confirm="againRemit"
    >
      <van-icon name="warning" class="error_icon" color="#ff3d3d" />
      <p class="error_text">
        请确认您的账户是否收到打款，小额打款可能不会有短信提醒，若打款失败，您可在4小时后发起重新打款
      </p>
    </van-dialog>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      type: "",
      umsRegId: "",
      bank_acct_name: "",
      bank_name: "",
      bank_acct_no: "",
      trans_amt: "",
      errorShow: false,
    };
  },
  created() {
    this.type = this.$route.query.type;
    this.umsRegId = this.$route.query.umsRegId;
    this.getInfo();
  },
  methods: {
    async againRemit() {
      let params = {
        ums_reg_id: this.umsRegId,
        company_account: this.bank_acct_no,
        zwSelfContractType: this.type,
      };
      // 银行打款测试接口
      const res = await this.$apis.zzsignServe.requestAccountVerify(params);
      if (res.resultCode === "200") {
        if (res.data.res_code === "0000") {
          Toast("已触发重新打款");
        } else {
          Toast(res.data.res_msg);
        }
      } else {
        Toast("系统错误，请稍后重试。");
      }
      this.errorShow = false;
    },
    async getInfo() {
      const res = await this.$apis.zzsignServe.signProgress({
        type: this.type,
      });
      if (res.data && res.data.resCode === "0000") {
        const { bankAcctNo, bankAcctName, bankName } =
          res.content.selfContractBaseInfo;
        this.bank_acct_name = bankAcctName;
        this.bank_name = bankName;
        this.bank_acct_no = bankAcctNo;
      }
    },
    async toVerify() {
      let params = {
        company_account: this.bank_acct_no,
        trans_amt: parseInt(`${this.trans_amt * 100}`),
        ums_reg_id: this.umsRegId,
        zwSelfContractType: this.type,
      };
      const res = await this.$apis.zzsignServe.amountVerification(params);
      if (res.resultCode === "200") {
        if (res.data.res_code === "0000") {
          this.$router.replace(
            `/service-sign/agreement-sign?type=${this.type}&umsRegId=${this.umsRegId}`
          );
          // let data = {
          //   ums_reg_id: this.umsRegId,
          //   zwSelfContractType: this.type,
          // };
          // // 获取签约页面接口
          // const response = await this.$apis.zzsignServe.agreementSign(data);
          // if (response.resultCode === "200") {
          //   if (Object.keys(response.content)) {
          //     window.open(response.content.url, "_blank");
          //   }
          // } else {
          //   Toast("系统错误，请稍后重试。");
          // }
        } else {
          Toast(res.data.res_msg);
        }
      } else {
        Toast("系统错误，请稍后重试。");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.verification_box {
  background: #f5f5f5;
  min-height: calc(100vh - 44px);
  padding: 15px 12px 0;
  position: relative;
  .verification_warning {
    font-size: 12px;
    color: #ff3d3d;
    line-height: 20px;
  }
  .verification_form {
    margin-top: 14px;
    border-radius: 8px;
    overflow: hidden;
    &::v-deep .van-cell {
      padding: 17px 12px;
      .van-cell__title {
        color: #333;
      }
      .van-field__control {
        color: #333;
      }
    }
  }
  .verification_error {
    margin-top: 15px;
    font-size: 13px;
    color: #4a79f1;
    line-height: 19px;
    text-align: center;
  }
  .verification_btn_box {
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 6px 15px;
    background-color: #fff;
    width: 100%;
    .verification_btn {
      width: 100%;
      height: 44px;
    }
  }
}

.error_icon {
  margin-top: 25px;
  width: 100%;
  text-align: center;
  font-size: 35px;
}
.error_text {
  margin-top: 17px;
  margin-bottom: 15px;
  padding: 0 20px;
  font-size: 14px;
  color: #333333;
  line-height: 21px;
  text-align: center;
}
</style>